/**
 * Check if the current device is mobile
 * @returns {boolean}
 */

const isMobile = () => {
	return window.innerWidth < 992;
};

const ensureNumber = (value) => {
	if (typeof value === "number" && !isNaN(value)) {
		return value;
	} else if (typeof value === "string" && !isNaN(value.trim())) {
		return Number(value);
	} else {
		throw new Error("Value cannot be converted to a number");
	}
};

window.bootstrap = Object.assign(window.bootstrap || {}, {
	isMobile,
	ensureNumber,
});

export { isMobile, ensureNumber };
